import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dLeibniz from "../Data.Leibniz/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Partial from "../Partial/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dValue from "../Restaumatic.Form.Value/index.js";
const $Result = (_1, _2) => ({tag: "Result", _1, _2});
const show = /* #__PURE__ */ Data$dShow.showArrayImpl(/* #__PURE__ */ Data$dShow.showArrayImpl(/* #__PURE__ */ (() => {
  const $0 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
  return record => {
    if (record.fieldLabel.tag === "Just") {
      return "{ fieldLabel: (Just " + Data$dShow.showStringImpl(record.fieldLabel._1) + ")" + (() => {
        if (record.fieldName.tag === "Just") {
          return ", fieldName: (Just " + $0(record.fieldName._1) + ")" + (record.internal
            ? ", internal: true, message: " + Data$dShow.showStringImpl(record.message) + " "
            : ", internal: false, message: " + Data$dShow.showStringImpl(record.message) + " ");
        }
        if (record.fieldName.tag === "Nothing") {
          if (record.internal) { return ", fieldName: Nothing, internal: true, message: " + Data$dShow.showStringImpl(record.message) + " "; }
          return ", fieldName: Nothing, internal: false, message: " + Data$dShow.showStringImpl(record.message) + " ";
        }
        $runtime.fail();
      })() + "}";
    }
    if (record.fieldLabel.tag === "Nothing") {
      if (record.fieldName.tag === "Just") {
        return "{ fieldLabel: Nothing, fieldName: (Just " + $0(record.fieldName._1) + ")" + (record.internal
          ? ", internal: true, message: " + Data$dShow.showStringImpl(record.message) + " "
          : ", internal: false, message: " + Data$dShow.showStringImpl(record.message) + " ") + "}";
      }
      if (record.fieldName.tag === "Nothing") {
        if (record.internal) { return "{ fieldLabel: Nothing, fieldName: Nothing, internal: true, message: " + Data$dShow.showStringImpl(record.message) + " }"; }
        return "{ fieldLabel: Nothing, fieldName: Nothing, internal: false, message: " + Data$dShow.showStringImpl(record.message) + " }";
      }
      $runtime.fail();
    }
    $runtime.fail();
  };
})()));
const Result = value0 => value1 => $Result(value0, value1);
const functorResult = {
  map: f => m => $Result(
    m._1,
    (() => {
      if (m._2.tag === "NoValue") { return Restaumatic$dForm$dValue.$Value("NoValue", m._2._1); }
      if (m._2.tag === "SomeValue") { return Restaumatic$dForm$dValue.$Value("SomeValue", f(m._2._1)); }
      $runtime.fail();
    })()
  )
};
const hasFieldResultResult = dictHasField => ({getField: label => functorResult.map(dictHasField.getField(label))});
const applyResult = {
  apply: v => v1 => $Result(
    Data$dMap$dInternal.unsafeUnionWith(Restaumatic$dForm$dFinal.ordMaybe.compare, Data$dFunction.const, v._1, v1._1),
    Restaumatic$dForm$dValue.applyValue.apply(v._2)(v1._2)
  ),
  Functor0: () => functorResult
};
const semigroupResult = dictSemigroup => (
  {
    append: (() => {
      const $0 = dictSemigroup.append;
      return a => b => applyResult.apply(functorResult.map($0)(a))(b);
    })()
  }
);
const applicativeResult = {pure: x => $Result(Restaumatic$dForm$dFinal.monoidFormErrors.mempty, Restaumatic$dForm$dValue.$Value("SomeValue", x)), Apply0: () => applyResult};
const monoidResult = dictMonoid => {
  const semigroupResult1 = semigroupResult(dictMonoid.Semigroup0());
  return {mempty: $Result(Restaumatic$dForm$dFinal.monoidFormErrors.mempty, Restaumatic$dForm$dValue.$Value("SomeValue", dictMonoid.mempty)), Semigroup0: () => semigroupResult1};
};
const additiveResult = dictAdditive => (
  {
    zero: $Result(Restaumatic$dForm$dFinal.monoidFormErrors.mempty, Restaumatic$dForm$dValue.$Value("SomeValue", dictAdditive.zero)),
    add: (() => {
      const $0 = dictAdditive.add;
      return a => b => applyResult.apply(functorResult.map($0)(a))(b);
    })(),
    sub: (() => {
      const $0 = dictAdditive.sub;
      return a => b => applyResult.apply(functorResult.map($0)(a))(b);
    })()
  }
);
const unsafeInvalid = e => $Result(e, Restaumatic$dForm$dValue.$Value("NoValue", Data$dLeibniz.refl));
const toTotal = v => {
  if (v._2.tag === "SomeValue") { return v._2._1; }
  if (v._2.tag === "NoValue") {
    return Partial._crashWith("Expected a Total result, got no value, errors=" + show(Data$dArray.fromFoldableImpl(Data$dMap$dInternal.foldableMap.foldr, v._1)));
  }
  $runtime.fail();
};
const toStrict = v => {
  if (v._2.tag === "SomeValue") {
    if (v._1.tag === "Leaf") { return Data$dEither.$Either("Right", v._2._1); }
    return Data$dEither.$Either("Left", v._1);
  }
  return Data$dEither.$Either("Left", v._1);
};
const toLax = v => {
  if (v._2.tag === "SomeValue") { return Data$dEither.$Either("Right", v._2._1); }
  if (v._2.tag === "NoValue") { return Data$dEither.$Either("Left", v._1); }
  $runtime.fail();
};
const mapErrors = f => v => $Result(f(v._1), v._2);
const liftMaybe = v => {
  if (v.tag === "Nothing") { return $Result(Restaumatic$dForm$dFinal.unknownError, Restaumatic$dForm$dValue.$Value("NoValue", Data$dLeibniz.refl)); }
  if (v.tag === "Just") { return $Result(Restaumatic$dForm$dFinal.monoidFormErrors.mempty, Restaumatic$dForm$dValue.$Value("SomeValue", v._1)); }
  $runtime.fail();
};
const invalidPrf = prf => e => $Result(e, Restaumatic$dForm$dValue.$Value("NoValue", prf));
const invalid = /* #__PURE__ */ invalidPrf(Data$dLeibniz.refl);
const liftV = v2 => {
  if (v2.tag === "Left") { return $Result(v2._1, Restaumatic$dForm$dValue.$Value("NoValue", Data$dLeibniz.refl)); }
  if (v2.tag === "Right") { return $Result(Restaumatic$dForm$dFinal.monoidFormErrors.mempty, Restaumatic$dForm$dValue.$Value("SomeValue", v2._1)); }
  $runtime.fail();
};
const heytingAlgebraFinal = dictHeytingAlgebra => (
  {
    ff: $Result(Restaumatic$dForm$dFinal.monoidFormErrors.mempty, Restaumatic$dForm$dValue.$Value("SomeValue", dictHeytingAlgebra.ff)),
    tt: $Result(Restaumatic$dForm$dFinal.monoidFormErrors.mempty, Restaumatic$dForm$dValue.$Value("SomeValue", dictHeytingAlgebra.tt)),
    implies: (() => {
      const $0 = dictHeytingAlgebra.implies;
      return a => b => applyResult.apply(functorResult.map($0)(a))(b);
    })(),
    conj: (() => {
      const $0 = dictHeytingAlgebra.conj;
      return a => b => applyResult.apply(functorResult.map($0)(a))(b);
    })(),
    disj: (() => {
      const $0 = dictHeytingAlgebra.disj;
      return a => b => applyResult.apply(functorResult.map($0)(a))(b);
    })(),
    not: functorResult.map(dictHeytingAlgebra.not)
  }
);
const getErrors = v => Data$dArray.concat(Data$dArray.fromFoldableImpl(Data$dMap$dInternal.foldableMap.foldr, v._1));
const andThenA = dictApplicative => {
  const map2 = dictApplicative.Apply0().Functor0().map;
  return v => v1 => {
    if (v._2.tag === "NoValue") { return dictApplicative.pure($Result(v._1, Restaumatic$dForm$dValue.$Value("NoValue", v._2._1))); }
    if (v._2.tag === "SomeValue") {
      const $0 = v._1;
      return map2(v2 => $Result(Data$dMap$dInternal.unsafeUnionWith(Restaumatic$dForm$dFinal.ordMaybe.compare, Data$dFunction.const, $0, v2._1), v2._2))(v1(v._2._1));
    }
    $runtime.fail();
  };
};
const andThen = v => v1 => {
  if (v._2.tag === "NoValue") { return $Result(v._1, Restaumatic$dForm$dValue.$Value("NoValue", v._2._1)); }
  if (v._2.tag === "SomeValue") {
    const v2 = v1(v._2._1);
    return $Result(Data$dMap$dInternal.unsafeUnionWith(Restaumatic$dForm$dFinal.ordMaybe.compare, Data$dFunction.const, v._1, v2._1), v2._2);
  }
  $runtime.fail();
};
export {
  $Result,
  Result,
  additiveResult,
  andThen,
  andThenA,
  applicativeResult,
  applyResult,
  functorResult,
  getErrors,
  hasFieldResultResult,
  heytingAlgebraFinal,
  invalid,
  invalidPrf,
  liftMaybe,
  liftV,
  mapErrors,
  monoidResult,
  semigroupResult,
  show,
  toLax,
  toStrict,
  toTotal,
  unsafeInvalid
};
